import { useAuth0 } from '@auth0/auth0-react';
import { faTwitch } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from '@playcastdotio/Shadcn';
import { useEffect, useState } from 'react';
import { Form, Link, useNavigate } from 'react-router-dom';
import { ruleState } from '../../api/stores';

export const Sts = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [stsPageHeader, setStsPageHeader] = useState('TwitchCon San Diego');

  useEffect(() => {
    if (isAuthenticated || !ruleState.currentState.requireAuthOnDeck) {
      navigate('/j/sts');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    console.log(window.location.origin.concat('/sts'));
    loginWithRedirect({
      authorizationParams: {
        scope: 'openid profile email',
        redirect_uri: window.location.origin.concat('/sts'),
      },
    });
  };

  // const handleContinue = (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();
  //   console.log('Continue');
  //   // redirect to deck page
  // };

  return (
    <div className='w-full h-screen m-0 p-0 bg-hero bg-cover bg-no-repeat bg-content text-content-text'>
      <div className='container mx-auto w-full h-auto py-10 px-8'>
        <section id='hero' className='grid grid-cols-12 gap-y-8 gap-x-4'>
          <div className='col-span-full flex flex-row flex-grow align-middle justify-center gap-x-2 pt-3 items-center'>
            <img src='/images/playcast_logo-96x96.png' alt='Logo' className='w-12 h-12' />
            <h1 className='md:pt-2 text-content-text-headline text-3xl font-bold font-headline'>
              <Link to='/'>Playcast</Link>
            </h1>
          </div>
        </section>

        <section className='mt-8 text-center flex flex-col space-y-6 items-center'>
          <h1 className='font-[Syne] text-3xl font-medium'>{stsPageHeader}</h1>
          <Button
            type='submit'
            onClick={handleLogin}
            className='rounded-full font-bold p-3 rounded-lg flex items-center justify-center space-x-2 shadow-lg w-full lg:w-1/3 transition-colors'
          >
            Login
          </Button>
          {/* <span>Or</span>
          <div className='row-auto w-full gap-2 lg:w-1/3'>
            <Form onSubmit={handleContinue}>
              <Input
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                type='text'
                id='phoneNumber'
                name='phoneNumber'
                required
                placeholder='Phone Number'
                className='w-full h-auto rounded border-none shadow-sm py-3 px-4 mb-2 bg-content text-center text-lg'
              />
              <Button type='submit' className='rounded-full'>
                Continue
              </Button>
            </Form>
          </div> */}
        </section>
      </div>
    </div>
  );
};
